import { VALID_PAYMENT_GROUP_TYPES, VALID_PAYMENT_METHODS } from "@swiggy-private/payment-types";

export const CHANGE = "Change";
export const CHANGE_PAYMENT_OPTION = "Change payment option";
export const TURBO_PAYMENT_COMMS = {
    SLIDE_TO_PAY_FOR_COD: "Slide to place your order with Cash on delivery!",
    SLIDE_TO_PAY: "Swipe to pay with your most preferred payment option",
    TO_PAY_V2: "Your preferred payment option has been selected",
    CHANGE: "Tap here to choose other payment methods",
    OFFER_COMMS_FALLBACK: "Use this payment option to SAVE MORE!",
};
export const RUPEE = "Rupee";
export const CHANGE_PAYMENT_CTA_ARIA_LABEL = "Change payment method";
export const CURRENTLY_PAYING_USING = "Currently paying using";
export const PAY_USING_ACCESSIBILITY_LABEL = "Pay {0} using {1}";
export const TURBO_WIDGET_GROUP_ARIA_LABEL = "Turbo payment";
export const CARD_NAME = "{0} card";
export const SLIDE_TO_PAY_PREFIX = "Slide to Pay";
export const SLIDE_TO_PAY_AMOUNT = "\u20B9{0}";
export const PAY_TEXT = "Pay";
export const PAY_INSTANTLY_SUBTEXT_TURBO_WIDGET = "Pay Instantly";
export const PAY_USING = "Pay using";
export const TURBO_AUTO_PAY_CTA_TEXT = "Pay \u20B9{0} after ordering";

export const DEFAULT_SLIDE_TO_PAY_PREFIX = {
    [VALID_PAYMENT_METHODS.COD]: "Place Cash Order",
};

export const SLIDE_UPDATE_THROTTLE_TIME = 200;
export const SLIDE_BUMP_ANIMATION_SHOWN = "slide-to-pay-bump-animation-shown";
export const INSTANT_PAYMENT_SUBTEXT_SHOWN = "turbo-payment-instant-payment-subtext";
export const INSTANT_PAYMENT_SUBTEXT_MAX_IMPRESSION_COUNT = 3;
export const BUMP_ANIMATION_TIMEOUT = 2000;

export const TURBO_WALLET_BALANCE_TEXT = "Balance:";

export const LOADING_OFFER_CTA = "Checking offer Details";

export const INSTANT_PAYMENT_FOP_LIST = [
    VALID_PAYMENT_GROUP_TYPES.WALLET,
    VALID_PAYMENT_GROUP_TYPES.WALLET_WEB,
    VALID_PAYMENT_GROUP_TYPES.SWIGGY_INSTRUMENTS,
    VALID_PAYMENT_GROUP_TYPES.PAY_LATER,
];

export const PAYMENT_METHOD_DOWNTIME_HALFCARD_TEXTS = {
    TAG: "SMART CHOICE!",
    TITLE: "Here’s how it works:",
    POINT1: "Order now & try paying while tracking your order.",
    POINT2: "You can also pay via Cash or {0} at the time of delivery.",
    CTA: "Great, pay after ordering",
};

export const POP_COLORS = {
    PRIMARY: "#CAFE33",
    TEXT_PRIMARY: "#0B1B17",
};

export const RBI_GUIDELINES_TOOLTIP_KEY = "turbo_empty_single_click_tooltip";
